import styled from 'styled-components';
import { AA_TEXT_PRIMARY_ON_LIGHT } from '~/modules/Helper/contrast.helper';

export const Painel = styled.section`
  border: 1px solid #e6e8eb;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 12px;
`;

export const Cabecalho = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f1f3;
`;

export const Titulo = styled.h2`
  margin: 0;
  color: #3d4450;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const Selo = styled.span`
  background: #e7f6f1;
  border-radius: 999px;
  color: #1f8a70;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 2px 8px;
  text-transform: uppercase;
`;

export const Corpo = styled.div`
  padding: 12px 16px 16px;
`;

export const Grade = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`;

export const Campo = styled.div`
  grid-column: ${({ $cheia }) => ($cheia ? '1 / -1' : 'auto')};
`;

export const Rotulo = styled.div`
  color: rgba(0, 0, 0, 0.45);
  font-size: ${({ theme }) => `${13 + theme.zoomFonte}px`};
`;

export const Valor = styled.div`
  margin-top: 4px;
  font-weight: 600;
  color: ${AA_TEXT_PRIMARY_ON_LIGHT};
  font-size: ${({ theme }) => `${14 + 2 * theme.zoomFonte}px`};
`;

export const Faixa = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: 22px;
  row-gap: 6px;
`;

export const Par = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
`;

export const RotuloLinha = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-size: ${({ theme }) => `${12 + theme.zoomFonte}px`};
  font-weight: 400;
`;

export const ValorLinha = styled.span`
  color: ${AA_TEXT_PRIMARY_ON_LIGHT};
  font-size: ${({ theme }) => `${14 + theme.zoomFonte}px`};
  font-weight: 500;
`;

export const ArquivoLinha = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const ArquivoIcone = styled.span`
  display: flex;
  flex: 0 0 auto;
  font-size: 20px;
  line-height: 1;
`;

export const ArquivoTexto = styled.span`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
`;

export const ArquivoNome = styled.span`
  color: ${AA_TEXT_PRIMARY_ON_LIGHT};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ArquivoLegenda = styled.span`
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.45);
  font-size: ${({ theme }) => `${12 + theme.zoomFonte}px`};
  font-weight: 400;
  line-height: 1.3;
`;
